import { HttpRequest } from './HttpRequest'

const ViewDataFromEmailApiPost = async (objectSearch: any, urlString: string) => {
    let data = JSON.stringify(objectSearch)
    try {
        const response = await HttpRequest().post(urlString, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export const GetEmailTransfer = async (objectSearch: any) => 
    await ViewDataFromEmailApiPost(objectSearch, `/viewdata/emailTransfer`)

export const GetEmailAlertSummaryTransfer = async (objectSearch: any) => 
    await ViewDataFromEmailApiPost(objectSearch, `/viewdata/emailalertsummarytransfer`)

export const GetUnitTransfered =async (objectSearch: any) => 
    await ViewDataFromEmailApiPost(objectSearch, `/viewdata/unittransfered`)

export const GetEmailAlertDaily = async (objectSearch: any) => 
    await ViewDataFromEmailApiPost(objectSearch, `/viewdata/emailalertdaily`)

export const GetEmailAlertSevenInspection = async (objectSearch: any) =>
    await ViewDataFromEmailApiPost(objectSearch, `/viewdata/emailalertseveninspection`)

export const GetEmailTransferDetail = async (objectSearch: any) =>
    await ViewDataFromEmailApiPost(objectSearch, `/viewdata/emailtransferdetail`)

export const GetReportEmailTransferSummary = async (objectSearch: any) => await ViewDataFromEmailApiPost(objectSearch, `/viewdata/reportemailtransfersummary`)
